import { render, staticRenderFns } from "./ClinicDashboardProducts.vue?vue&type=template&id=31c7af50&"
import script from "./ClinicDashboardProducts.vue?vue&type=script&lang=js&"
export * from "./ClinicDashboardProducts.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDashboardProducts.vue?vue&type=style&index=0&id=31c7af50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports